// Language switching is off for the general public: the IP country decides the
// language (Srpski in SRPSKI_COUNTRIES, English everywhere else) and no picker
// is rendered anywhere.
//
// A visitor who lands on a link carrying ?lang=1 unlocks the feature for good —
// the unlock is persisted in localStorage, so it survives later visits that
// don't carry the param. Unlocked visitors get a one-time popup asking which
// language they want, and the language picker in the header from then on.

export const UNLOCK_PARAM = 'lang';

const UNLOCK_KEY = 'languageUnlocked';
const CHOSEN_KEY = 'languageChosen';
const LANGUAGE_KEY = 'language';
const DETECTED_KEY = 'detectedLanguage';

export const DEFAULT_LANGUAGE = 'BA';

const SRPSKI_COUNTRIES = ['RS', 'HR', 'BA'];

// The languages actually on offer today. The local one keeps the code 'BA'
// because the API content columns are nameBA / nameRU — only its label changed.
export const OFFERED_LANGUAGES = [
  { code: 'BA', label: 'SR', name: 'Srpski' },
  { code: 'US', label: 'EN', name: 'English' },
  { code: 'RU', label: 'RU', name: 'Русский' },
];

// localStorage throws in Safari private mode — never let that break the site.
const read = (key) => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

const write = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* ignore */
  }
};

// Run at startup: consume ?lang=1 and persist the unlock. Idempotent.
export function initLanguageAccess() {
  if (read(UNLOCK_KEY) === '1') return true;
  let hasParam = false;
  try {
    hasParam = new URLSearchParams(window.location.search).get(UNLOCK_PARAM) === '1';
  } catch {
    hasParam = false;
  }
  if (hasParam) write(UNLOCK_KEY, '1');
  return hasParam;
}

export function storedLanguage() {
  return read(LANGUAGE_KEY);
}

// The language to render before the IP lookup answers. Returning visitors get
// their last detected language, so they don't see a flash of Srpski.
export function initialLanguage(unlocked) {
  return (unlocked && storedLanguage()) || read(DETECTED_KEY) || DEFAULT_LANGUAGE;
}

// Called with the IP country. An unlocked visitor's own pick always wins, and an
// empty country (the lookup gave no answer) means Srpski.
export function languageForCountry(country, unlocked) {
  const detected = !country || SRPSKI_COUNTRIES.includes(country) ? DEFAULT_LANGUAGE : 'US';
  write(DETECTED_KEY, detected);
  return (unlocked && storedLanguage()) || detected;
}

// The popup is shown to unlocked visitors until they answer it once.
export function hasChosenLanguage() {
  return read(CHOSEN_KEY) === '1';
}

export function markLanguageChosen() {
  write(CHOSEN_KEY, '1');
}
